export default __webpack_public_path__ + "static/media/update_1.0bdb32f5.png";